import { CardTest } from "../styles/Card";

const ViewNumberFive = ({ formInvest, setFormInvest }) => {
  // Choice One
  const onChangeChoiceOne = (e) => {
    let value = e.target.value;
    if (value === "one") {
      setFormInvest({
        ...formInvest,
        five_question_choice_one: true,
        five_question_choice_two: false,
        five_question_choice_three: false,
        five_question_choice_four: false,
      });
    }
  };

  // Choice Two
  const onChangeChoiceTwo = (e) => {
    let value = e.target.value;
    if (value === "two") {
      setFormInvest({
        ...formInvest,
        five_question_choice_one: false,
        five_question_choice_two: true,
        five_question_choice_three: false,
        five_question_choice_four: false,
      });
    }
  };

  // Choice Three
  const onChangeChoiceThree = (e) => {
    let value = e.target.value;
    if (value === "three") {
      setFormInvest({
        ...formInvest,
        five_question_choice_one: false,
        five_question_choice_two: false,
        five_question_choice_three: true,
        five_question_choice_four: false,
      });
    }
  };

  // Choice Four
  const onChangeChoiceFour = (e) => {
    let value = e.target.value;
    if (value === "four") {
      setFormInvest({
        ...formInvest,
        five_question_choice_one: false,
        five_question_choice_two: false,
        five_question_choice_three: false,
        five_question_choice_four: true,
      });
    }
  };

  return (
    <div className=" bg-gray50 p-4 mt-5 rounded-[10px] ">
      <div className=" text-maincyan text-xs">คำถามที่ 5 จาก 10</div>
      <CardTest
        choice1={<div>ไม่เกิน 1 ปี</div>}
        choice2={<div>1 ถึง 3 ปี</div>}
        choice3={<div>3 ถึง 5 ปี</div>}
        choice4={<div>มากกว่า 5 ปี</div>}
        value1={"one"}
        value2={"two"}
        value3={"three"}
        value4={"four"}
        onChange1={onChangeChoiceOne}
        onChange2={onChangeChoiceTwo}
        onChange3={onChangeChoiceThree}
        onChange4={onChangeChoiceFour}
        checked1={formInvest?.five_question_choice_one}
        checked2={formInvest?.five_question_choice_two}
        checked3={formInvest?.five_question_choice_three}
        checked4={formInvest?.five_question_choice_four}
        question="5. ระยะเวลาที่ท่านคาดว่าจะไม่มีความจำเป็น
        ต้องใช้เงินลงทุนนี้"
      />
    </div>
  );
};

export default ViewNumberFive;
